import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import {
  BELT_ORDER,
  GraduationProgress,
  getBeltLabel,
  getGradeLabel,
} from './studentGraduation';

interface GraduationDialogProps {
  open: boolean;
  progress: GraduationProgress;
  selectedBelt: string;
  selectedStripes: string;
  graduationNote: string;
  isSaving: boolean;
  onClose: () => void;
  onSave: () => void;
  onBeltChange: (belt: string) => void;
  onStripesChange: (stripes: string) => void;
  onNoteChange: (note: string) => void;
}

export default function GraduationDialog({
  open,
  progress,
  selectedBelt,
  selectedStripes,
  graduationNote,
  isSaving,
  onClose,
  onSave,
  onBeltChange,
  onStripesChange,
  onNoteChange,
}: GraduationDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pb: 1 }}>Graduar alumno</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            Sugerencia: <strong>{progress.objective}</strong>. Puedes ajustar cinturón y grado
            antes de guardar.
          </Typography>
          <FormControl fullWidth size="small">
            <InputLabel id="graduation-belt-label">Cinturón</InputLabel>
            <Select
              labelId="graduation-belt-label"
              label="Cinturón"
              value={selectedBelt}
              onChange={(event) => onBeltChange(event.target.value)}
            >
              {BELT_ORDER.map((belt) => (
                <MenuItem key={belt} value={belt}>
                  {getBeltLabel(belt)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth size="small">
            <InputLabel id="graduation-stripes-label">Grado</InputLabel>
            <Select
              labelId="graduation-stripes-label"
              label="Grado"
              value={selectedStripes}
              onChange={(event) => onStripesChange(event.target.value)}
            >
              {[0, 1, 2, 3, 4].map((stripe) => (
                <MenuItem key={stripe} value={stripe.toString()}>
                  {getGradeLabel(stripe)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Nota del profesor"
            value={graduationNote}
            onChange={(event) => onNoteChange(event.target.value)}
            fullWidth
            multiline
            minRows={2}
            size="small"
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={isSaving || !selectedBelt}
          sx={{
            bgcolor: '#111111',
            textTransform: 'none',
            '&:hover': { bgcolor: '#2a2a2a' },
          }}
        >
          Guardar graduación
        </Button>
      </DialogActions>
    </Dialog>
  );
}
